import { TaskDetailsResponseM } from './../../modules/shared/models/task/task-details.model';
import { StatusGroupIds, TypeGroupIds } from './../../modules/shared/constants/category-groupid.constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccountUserService } from '../../service/account.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ReAssignTaskPayload } from 'src/app/modules/shared/models/create-task/reAssign.model';

@Injectable({
    providedIn: 'root'
})

export class TasksService {

    appUrl = "";
    apiUrl = ""
    localAppUrl = "";
    messApi = '';
    user: any;
    loginAppUrl = "";
    activityUrl = "";
    taskUrl = "";
    objectTaskUrl = "";
    public taskCreateUpdate = new Subject<any>();
    public taskfilterMode$ : BehaviorSubject<boolean> = new BehaviorSubject(false);
    private timerRunningTasksSubject = new BehaviorSubject<any[]>([]);
    private taskDeleteSubject = new Subject<void>();
    taskDelete$ = this.taskDeleteSubject.asObservable();

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
        this.accountUserService.user.subscribe(x => this.user = x);
        this.appUrl = environment.appUrl;
        this.apiUrl = environment.apiUrl;
        this.messApi = environment.apiStreamUrl;
        this.localAppUrl = environment.localApiUrl;
        this.loginAppUrl = environment.appOrgUrlconfig + "Login";
        this.activityUrl = environment.activity + '/LionO360/2.0/API/';
        this.taskUrl = environment.activity + '/LionO360/2.0/API/Task';
        this.objectTaskUrl = this.activityUrl + 'ObjectTask';
    }



    public createUpdateTask(data) {
        this.taskCreateUpdate.next(data);
    }

  //Behavior Subject for Refresh Task list

  getTaskRefreshList(): Observable<any> {
    return this.taskfilterMode$.asObservable();
  }

  setTaskRefreshList(isRefresh) {
    this.taskfilterMode$.next(isRefresh);
  }

    getUsers(organizationId: number) {
        return this.http.get<any>(environment.appOrgUrl + `User?organizationId=${organizationId}&includeDeleted=false&inActive=false&both=true`)
          .toPromise()
          .then(res => res);
      }

    getTaskStatuses() {
        return this.http.get<any>(this.activityUrl + "Status?groupId=" + StatusGroupIds.TaskStatusGroupId)
            .toPromise()
            .then(res => res);
    }

    getAllAssociation(): Observable<any> {
        return this.http.get<any>(`${this.appUrl}Type?groupId=${TypeGroupIds.ContactAssociationTicketAPI}`);
    }

    updateTask(task) {
        return this.http.put(this.taskUrl, task)
            .toPromise()
            .then(res => res);
    }

    changeTaskStatus(task) {
        const url = `${this.taskUrl}/Status`;

        return this.http.put(url, task)
            .toPromise()
            .then(res => res);
    }

    getTask(taskId: number) {
        const url = `${this.objectTaskUrl}/GetObjectTaskByTaskId/${taskId}`;

        return this.http.get<any>(url)
            .toPromise()
            .then(res => res);
    }
    //#region New Task API
    getTaskDetailForView(taskId: number): Observable<TaskDetailsResponseM>{
        return this.http.get<any>(`${this.objectTaskUrl}/${taskId}`
        )
    }

    getTaskTimerForView(taskId: number){
        return this.http.get<any>(`${this.activityUrl}TaskTime/TimeSpentByTaskId/${taskId}`
        )
    }

    getTaskTimerHistroyForView(taskId: number){
        return this.http.get<any>(`${this.activityUrl}TaskTime/TimeSpentDetailByTaskId/${taskId}`
        )
    }

    startTaskTimer(taskId: number){
        return this.http.post<any>(`${this.activityUrl}TaskTime/StartTimer`, {taskId: taskId});
    }

    stopTaskTimer(timerId: number){
        return this.http.put<any>(`${this.activityUrl}TaskTime/StopTimer`, {id: timerId});
    }

    markCheckedList(checkListId: any){
        return this.http.put<any>(`${this.activityUrl}Task/TaskCheckList`, checkListId
        )
    }

    deleteTask(taskId: number){
        return this.http.delete<any>(`${this.activityUrl}ObjectTask/${taskId}`
        )
    }
    
    deleteSubTask(taskId: number){
        return this.http.delete<any>(`${this.activityUrl}Task/${taskId}`
        )
    }

    filteredAllTaskOwner(){
        return this.http.get<any>(`${environment.activity}/api/Filter/AllTaskOwner`)
    }

    filteredCreatedByUsers(){
        return this.http.get<any>(`${environment.activity}/api/Filter/CreatedByUsers`)
    }

    filteredPriority(){
        return this.http.get<any>(`${environment.activity}/api/Filter/Priority`)
    }

    filteredModule(){
        return this.http.get<any>(`${environment.activity}/api/Filter/Module`)
    }

    filteredAllTaskStatus(){
        return this.http.get<any>(`${environment.activity}/api/Filter/AllTaskStatus`)
    }

    filteredAllTaskLastUpdatedBy(){
        return this.http.get<any>(`${environment.activity}/api/Filter/UpdatedByUsers`)
    }

    getTasks1(data) {
        let url = "";
        url = this.taskUrl + '/GetOrganizationTaskPaginatedListWithFilter';

        return this.http.post<any>(url, data)
    }

    postExport(data){
        let url = "";
        url = this.apiUrl + 'ExportFile';
        return this.http.post<any>(url, data)
    }
    // getTasks1(data) {
    //      let url = "";
    //     url = this.taskUrl + '/GetOrganizationTaskPaginatedListWithFilter';

    //     return this.http.post<any>(url, data ,{ observe: 'response' })
    //         .toPromise()
    //         .then(res => ({
    //             tasks: res.body,
    //             headers: JSON.parse(res.headers.get('x-pagination'))
    //         }));
    // }

    getTasks(organizationId, pageNumber, pageSize, searchValue, seachFields, filterValue,childFilter, options?) {
        let url = this.taskUrl + "?organizationId=" + organizationId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize
            + '&filter=' + filterValue + '&isActive=true'+ "&childFilter=" + childFilter

        if (searchValue) {
            url = `${url}&SearchValue=${searchValue}&SearchColumns=${seachFields}`;
        }

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
        }

        if (!options || !options.sort) {
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                tasks: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    setTimerRunningTaskData(tasks: any[]) {
        this.timerRunningTasksSubject.next(tasks);
    }

    getTimerRunningTaskData() {
        return this.timerRunningTasksSubject.asObservable();
    }

    clearTimerRunningTaskData() {
        this.timerRunningTasksSubject.next([]);
    }

    notifyTaskUpdate() {
        this.taskDeleteSubject.next();
    }

    reAssignTask(data: ReAssignTaskPayload){
        return this.http.post<any>(`${this.activityUrl}Task/ReAssign`,data
        )
    }

    getTaskListWithFilters(userFilter,data){
        return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/TaskList/TaskListFilter?userFilter=${userFilter}`, data)
    }
    getTaskGroupList(userFilter,data){
        return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/TaskList/TaskGroupList?userFilter=${userFilter}`, data)
    }
}
